import { FC, useEffect, useState } from "react";
import { Form } from "react-bootstrap";

interface Props {
  flex: number;
  defaultValue: string;
  placeholder?: string;
  onCommit: (value: string) => void;
}

const NameInput: FC<Props> = ({ flex, defaultValue, placeholder, onCommit }) => {
  const [value, setValue] = useState(defaultValue ?? "");
  const [editing, setEditing] = useState(false);

  useEffect(() => {
    if (!editing) setValue(defaultValue ?? "");
  }, [defaultValue]);

  const commit = () => {
    setEditing(false);
    if (value !== (defaultValue ?? "")) onCommit(value);
  };

  return (
    <div style={{ flex }}>
      <Form.Control
        type="text"
        placeholder={placeholder ?? "Name"}
        value={value}
        onFocus={() => setEditing(true)}
        onChange={(e) => setValue(e.target.value)}
        onBlur={commit}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            (e.target as HTMLInputElement).blur();
          }
        }}
      />
    </div>
  );
};

export default NameInput;
